import {useTranslation} from "react-i18next";
import {Button, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import Footer from "../../components/Footer";
import {ROUTES} from "../../router/config";
import {useCreateApplication} from "../../hooks/useCreateApplication";
import {useApplicationStorage} from "../../hooks/useApplicationStorage";
import "./WelcomePage.css";

const WelcomePage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {createApplication, isCreatingApplication} = useCreateApplication();
    const {setLead} = useApplicationStorage();

    const handleStart = async () => {
        try {
            const data = await createApplication();

            setLead({}, `lead_${data?.onlineRegistrationId}`);
            navigate(`${data?.onlineRegistrationId}/${ROUTES.PARENT}`);
        } catch {
            // fails silently
        }
    };

    return (
        <div className="WelcomePage">
            <div className="WelcomePage-content">
                <Typography variant="h1">
                    {t("welcome.title")}
                </Typography>
                <Typography variant="body1" component="div" className="mt-4">
                    {t("welcome.subtitle")}
                </Typography>
                <div className="divider mt-12 mb-12" />
                <Button
                    variant="accent"
                    className="w-full"
                    onClick={handleStart}
                    loading={isCreatingApplication}
                >
                    {t("welcome.startApplication")}
                </Button>
            </div>
            <Footer />
        </div>
    );
};

export default WelcomePage;
